import { defineComponent as _defineComponent } from 'vue';
import { createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = { class: "oasis-footer" };
const _hoisted_2 = { class: "footer-extra" };
const _hoisted_3 = { class: "flex flex-wrap gap-4" };
import FooterAcknowledgement from './footer-acknowledgement.vue';
import FooterBusinessInfo from './footer-business-info.vue';
import FooterContactLinks from './footer-contact-links.vue';
import FooterLegalLinks from './footer-legal-links.vue';
import FooterPartnerLinks from './footer-partner-links.vue';
import FooterSocialLinks from './footer-social-links.vue';
export default /*@__PURE__*/ _defineComponent({
    __name: 'oasis-footer',
    props: {
        isAuthenticated: { type: Boolean, default: false },
        contactLinks: {},
        legalLinks: {},
        partnerLinks: {},
        socialLinks: {}
    },
    setup(__props) {
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("footer", _hoisted_1, [
                _createVNode(FooterAcknowledgement),
                _createElementVNode("div", _hoisted_2, [
                    _createElementVNode("div", _hoisted_3, [
                        _createVNode(FooterContactLinks, {
                            links: _ctx.contactLinks,
                            "is-authenticated": _ctx.isAuthenticated,
                            class: "flex-grow"
                        }, null, 8, ["links", "is-authenticated"]),
                        _createVNode(FooterSocialLinks, { links: _ctx.socialLinks }, null, 8, ["links"])
                    ]),
                    _createVNode(FooterPartnerLinks, { links: _ctx.partnerLinks }, null, 8, ["links"]),
                    _createVNode(FooterBusinessInfo),
                    _createVNode(FooterLegalLinks, { links: _ctx.legalLinks }, null, 8, ["links"])
                ])
            ]));
        };
    }
});
